/* eslint-disable max-classes-per-file */
export class EmptySearchResultSegmentsError extends Error {
	constructor() {
		super();

		this.name = 'EmptySearchResultSegmentsError';
		Object.setPrototypeOf(this, EmptySearchResultSegmentsError.prototype);
	}
}

export class EmptyPricesForFareGroupsError extends Error {
	constructor() {
		super();
		this.name = 'EmptyPricesForFareGroupsError';
		Object.setPrototypeOf(this, EmptyPricesForFareGroupsError.prototype);
	}
}
